import type { State } from '../../interfaces/State';
import type { LearningMode } from '../reducers/learningMode';

export const selectLearningMode = (state: State): LearningMode => {
  return state.get('learningMode');
};
